import React from 'react';
import styles from './AdControl.module.scss';
import {IProduct} from 'data/interfaces/products';
import EditAdButton from './components/editAdButton/EditAdButton';
import ViewAdButton from './components/viewAdButton/ViewAdButton';
import CancelAdButton from './components/cancelAdButton/CancelAdButton';
import {Else, If, Then} from 'react-if';


export enum hideControl {
  edit = 1,
  delete = 2,
  view = 3,
}

interface IAdProps {
  product: IProduct;
  className?: string;
  hideControl?: hideControl[];

  view?: (id: number) => void
  edit?: (id: number) => void
  delete?: (id: number) => void
  loading?: boolean;
}


const AdControl = ({className, ...props}: IAdProps) => {
  return (
    <div className={`AdControl ${styles.adControlContainer} ${className}`.trim()}>
      <If condition={(Array.isArray(props.hideControl) && props.hideControl.includes(hideControl.view))}>
        <Then>
          {() => <div className="circleButton"/>}
        </Then>
        <Else>
          {() => <ViewAdButton className="circleButton" {...props}/>}
        </Else>
      </If>
      <If condition={(Array.isArray(props.hideControl) && props.hideControl.includes(hideControl.edit))}>
        <Then>
          {() => <div className="circleButton"/>}
        </Then>
        <Else>
          {() => <EditAdButton className="circleButton" {...props}/>}
        </Else>
      </If>
      <If condition={(Array.isArray(props.hideControl) && props.hideControl.includes(hideControl.delete))}>
        <Then>
          {() => <div className="circleButton"></div>}
        </Then>
        <Else>
          {() => <CancelAdButton className="circleButton" {...props}/>}
        </Else>
      </If>
    </div>
  );
};

AdControl.defaultProps = {
  product: {},

  view: () => {
  },
  edit: () => {
  },
  delete: () => {
  },
  className: '',
};
export default AdControl;
